// extracted by mini-css-extract-plugin
export default {"wrapper":"amount_wrapper__JifvA","payable":"amount_payable__Qh7wL","row":"amount_row__pcPxO","discount":"amount_discount__IWcu8","subscription":"amount_subscription__rmjKl"};